<script setup>
import Logo from "./Logo.vue";
import { useAppState } from '../stores/app-state';

    const appState = useAppState();

</script>

<template>
    <div class="topbar" :class="[appState.menuOpen ? 'active' : '' ]">
        <div class="logo-container">
            <Logo class="logo-top"/>
        </div>
    </div>
</template>
